import DeviceController from './deviceController';
import DeviceConverter from './deviceConverter';

class Device {
  
  constructor(params = {}) {
    
    Object.assign(this, {
      id: null,
      dateRegistered: '',
      macAddress: '',
      activeStatus: null,
      drynessStatus: null
    }, params);
  }
}

export {
  DeviceController,
  DeviceConverter
}
export default Device;


// WEBPACK FOOTER //
// ./src/models/device/device.js